// src/components/Admin/CustomerTree/CustomerTreeAdminPage.tsx

import React, { useEffect, useState } from 'react';
import { useUserRegistry } from '../../../hooks/useUserRegistry';
import { UserView, UserViewType } from '../../../types/user';
import { defaultViews } from '../../../support/config/tables';
import CustomerTreeTable from './CustomerTable'; // the table component below

const CustomerTreeAdminPage: React.FC = () => {
  const { userViews } = useUserRegistry();
  const [view, setView] = useState<UserView | null>(null);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      const views = userViews[UserViewType.CustomerTree];

      // Use first tree view or default
      const treeView =
        views?.find((v) => v.id === defaultViews[UserViewType.CustomerTree].id) ??
        views?.[0] ??
        defaultViews[UserViewType.CustomerTree];

      if (isMounted) {
        setView(treeView);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [userViews]);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(30);

  if (!view) {
    return <div style={{ padding: 16 }}>Loading tree view…</div>;
  }

  return (
    <CustomerTreeTable
      view={view}
      pageIndex={pageIndex}
      size={pageSize}
      onPageChange={setPageIndex}
    />
  );
};

export default CustomerTreeAdminPage;